import { Button } from '@travelnest/merlin.button';
import theme from '@travelnest/merlin.theme';
import { IEventV2 } from '@travelnest/typewriter';
import get from 'lodash.get';
import React, { useEffect, useState } from 'react';
import { IPostPayment } from '../../../../data/entities/post-payment/index';
import { FormInput, FormLabel, FormRow, FormSelect } from '../../form';
import { FormInputSymbol } from '../../form/form-input-symbol/FormInputSymbol';
import { currencies, IPostPaymentScenario, scenarios } from './helpers';

interface INewExceptionalPaymentComponentProps {
	expanded: boolean;
	event: IEventV2;
	submitPostPayments: (payments: IPostPayment[], eventId: string) => void;
}

export const NewExceptionalPaymentComponent: React.FC<INewExceptionalPaymentComponentProps> = (props) => {
	const [scenarioId, setScenarioId] = useState(Object.keys(scenarios)[0]);
	const [value, setValue] = useState(scenarios[scenarioId].defaultValue || 0);
	const [currency, setCurrency] = useState('GBP');
	const [reason, setReason] = useState(scenarios[scenarioId].defaultReason || '');

	const valueLabel = get(scenarios[scenarioId], 'value_label', 'Value');

	const classList = [
		'exceptional-payments__group',
		...(props.expanded ? [] : ['exceptional-payments__group--hidden'])
	];

	const isValueEditable = (scenario: IPostPaymentScenario) => scenario.value_type !== 'none';

	useEffect(() => {
		setValue(scenarios[scenarioId].defaultValue || 0);
		setReason(scenarios[scenarioId].defaultReason || '');
	}, [scenarioId]);

	return <div className={classList.join(' ')}>
		<div className="exceptional-payments__row">
			<FormRow>
				<FormLabel htmlFor="payment_type_select">Payment Type</FormLabel>
				<FormSelect onChange={(event) => setScenarioId(event.target.value)}>
					{Object.entries(scenarios).map(([id, scenario]) => <option key={id} value={id}>{scenario.name}</option>)}
				</FormSelect>
			</FormRow>

			<FormRow>
				<FormLabel htmlFor="payment_type_value">{valueLabel}</FormLabel>
				<FormInputSymbol
					symbol=""
					position="hidden"
					value={value}
					disabled={!isValueEditable(scenarios[scenarioId])}
					onChange={(event) => setValue(Number(event.target.value))}
				></FormInputSymbol>
			</FormRow>

			<FormRow>
				<FormLabel htmlFor="payment_type_currency">Currency</FormLabel>
				<FormSelect onChange={(event) => setCurrency(event.target.value)} disabled={!isValueEditable(scenarios[scenarioId])}>
					{currencies.map((c) => <option key={c} value={c}>{c}</option>)}
				</FormSelect>
			</FormRow>
		</div>

		<div className="exceptional-payments__row">
			<div className="exceptional-payments__input--expanded">
				<FormRow>
					<FormLabel htmlFor="payment_type_reason">Reason</FormLabel>
					<FormInput value={reason} widthtype="wide" onChange={(event) => setReason(event.target.value)} />
				</FormRow>
			</div>
		</div>

		<div className="exceptional-payments__row">
			<div className="exceptional-payments__column">
				<p>{scenarios[scenarioId].description}</p>
			</div>
			<div className="exceptional-payments__column">
				<ul>
					{scenarios[scenarioId].action_descriptions.map((description: string, i: number) => <li key={i}>{description}</li>)}
				</ul>
			</div>
		</div>

		<div className="exceptional-payments__row">
			<Button
				bgColor={theme.colours.neutral.darker}
				color={theme.colours.text.lightest}
				hoverColor={theme.colours.neutral.dark}
				onClick={(e) => props.submitPostPayments(
					scenarios[scenarioId].buildPayments(
						props.event,
						value,
						currency,
						reason === '' ? scenarios[scenarioId].name : `${scenarios[scenarioId].name} - ${reason}`
					),
					props.event.id
				)}
			>Submit</Button>
		</div>
	</div>;
};
